import React from 'react';
import { useContext } from 'react';
import { AuthContext } from '../App';
import { useTheme, ThemedCard, ThemedButton } from './ThemeContext';
import axios from 'axios';
import { endpoint } from '../apiConfig';

const LocalModeBanner = () => {
  const { user, isLocalOnly, logout } = useContext(AuthContext);
  const { woodStyles } = useTheme();
  
  if (!isLocalOnly) return null;
  
  const handleTryAgain = async () => {
    try {
      // Clear local storage first to ensure a clean state
      localStorage.removeItem('gameUser');
      localStorage.removeItem('token');
      
      // Attempt to create an anonymous user through API
      const response = await axios.post(endpoint('/api/anon'));
      
      if (response.data && response.data.token) {
        // Store the new anonymous user data
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('gameUser', JSON.stringify(response.data.user));
        
        // Refresh the page to reinitialize with the new user
        window.location.reload();
      } else {
        throw new Error('Failed to create anonymous user');
      }
    } catch (error) {
      console.error('Failed to reconnect:', error);
      // Force a reload anyway to try the default initialization flow
      window.location.reload();
    }
  };
  
  return (
    <ThemedCard className="mb-4 bg-yellow-100 dark:bg-yellow-900 border-yellow-400">
      <div className="p-3">
        <div className="flex items-start">
          <div className="mr-3 text-xl">⚠️</div>
          <div className="flex-1">
            <h3 className={`text-sm font-medium ${woodStyles.text.primary}`}>
              Local Mode Active
            </h3>
            <p className={`text-xs ${woodStyles.text.secondary} mb-2`}>
              Running with limited functionality due to API connection issues.
              Only local bot games are available.
            </p>
            <div className="flex mt-2">
              <ThemedButton
                onClick={handleTryAgain}
                variant="primary"
                className="text-xs py-1 px-2"
              >
                Try to Reconnect
              </ThemedButton>
            </div>
          </div>
        </div>
      </div>
    </ThemedCard>
  );
};

export default LocalModeBanner;